import React from 'react';
import PageLayout from '@components/layout/PageLayout';
import ErrorBoundary from '@components/common/ErrorBoundary';
import EvidenceUploadForm from '@components/features/evidence/EvidenceUploadForm';

const EvidenceUploadPage: React.FC = () => {
  return (
    <PageLayout>
      <ErrorBoundary level="page">
        <EvidenceUploadForm />
      </ErrorBoundary>
    </PageLayout>
  );
};

export default EvidenceUploadPage;
